"use client";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

export function MapFilterDrawer({
  open,
  setOpen,
  setClose,
  categories,
  setSelectedItems,
  selectedItems,
}) {
  function addRemoveItem(item) {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter((i) => i !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  }

  return (
    <div
      className={`absolute flex flex-col justify-betweentransition-all duration-500 bottom-0 space-y-8 left-0 right-0 w-full h-full bg-brand-wool ${
        open ? "translate-y-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center justify-between w-full px-8 pt-8">
        <h3 className="level-2">Filters</h3>
        <button
          onClick={setClose}
          className="flex items-center justify-center w-8 h-8 rounded-full cursor-pointer right-2 top-2 bg-foreground text-background"
        >
          <X />
        </button>
      </div>

      <div className="px-8 pb-8">
        <div className="flex flex-wrap gap-2 py-2">
          {categories.map((item, index) => (
            <Button
              size="sm"
              variant="outline"
              className={`${
                selectedItems.includes(item.value)
                  ? "bg-button text-button-foreground"
                  : ""
              }`}
              key={index}
              onClick={() => addRemoveItem(item?.value)}
            >
              {item?.label}
            </Button>
          ))}
        </div>
      </div>
      <div className="flex items-end justify-end flex-1 p-8">
        <Button
          size="sm"
          className=""
          variant="default"
          onClick={() => setSelectedItems([])}
        >
          Clear
        </Button>
      </div>
    </div>
  );
}
